// extracted by mini-css-extract-plugin
export default {"user_profile_link":"userCard_user_profile_link__tKC9R"};